import { PLATFORM } from 'aurelia-pal';
import baseConfiguration from '../../config/browser.config';

const appContainer = PLATFORM.moduleName('modules/app/containers/app/app.container');

export const configure = (aurelia) => {
  aurelia.use
  .standardConfiguration()
  .plugin(PLATFORM.moduleName('aurelia-validation'))
  .plugin(PLATFORM.moduleName('libs/oac'))
  .plugin(PLATFORM.moduleName('modules/ods'))
  .plugin(PLATFORM.moduleName('modules/oac'), {
    configuration: Object.assign({}, baseConfiguration, PLATFORM.global.appConfiguration),
  })
  .plugin(PLATFORM.moduleName('modules/app'))
  .plugin(PLATFORM.moduleName('modules/search'));

  return aurelia.start().then(() => aurelia.setRoot(appContainer));
};
